// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1PDct","savePackageButton":"ClientWallet_savePackageButton__Yj011"};